import PropTypes from 'prop-types';
import React from 'react';
import './HorizontalBar.scss';

export default class HorizontalBar extends React.PureComponent {
    static propTypes = {
        /**
         * Orientation of icons
         */
        content: PropTypes.node.isRequired,
    };

    render() {
        return (
            <div className="component-Layout-SideBar">
                <div className="landscape">{this.props.content}</div>
            </div>
        );
    }
}
